import { n as e } from "./types-CsIxq0a2.js";
import { faArrowDownToSquare as t, faArrowsSplitUpAndLeft as n, faBracketsCurly as r, faChartScatter as i, faCircleNodes as a, faCloud as o, faDatabase as s, faEthernet as c, faInfo as l, faPlay as u, faRefresh as d } from "@vintecc/pro-light-svg-icons";
import { faArrowDownToSquare as f, faArrowsSplitUpAndLeft as p, faBracketsCurly as m, faChartScatter as h, faCircleNodes as g, faCloud as _, faDatabase as v, faEthernet as y, faInfo as b, faPlay as x, faRefresh as S } from "@vintecc/pro-regular-svg-icons";
//#region src/constants/index.ts
var C = (C, w = (e, t) => t || e) => {
	let T = (e) => C.includes(`/${e}`);
	return [
		{
			title: w("configEditor.pages.general", "General"),
			path: e.General,
			icon: T(e.General) ? b : l,
			advanced: !1
		},
		{
			title: w("configEditor.pages.localStorage", "Local storage"),
			path: e.LocalStorage,
			icon: T(e.LocalStorage) ? v : s,
			advanced: !1
		},
		{
			title: w("configEditor.pages.collector", "Collector"),
			path: e.Collector,
			icon: T(e.Collector) ? f : t,
			advanced: !1
		},
		{
			title: w("configEditor.pages.replicator", "Replicator"),
			path: e.Replicator,
			icon: T(e.Replicator) ? p : n,
			advanced: !0
		},
		{
			title: w("configEditor.pages.adsRouter", "ADS router"),
			path: e.AdsRouter,
			icon: T(e.AdsRouter) ? g : a,
			advanced: !0
		},
		{
			title: w("configEditor.pages.syncer", "Syncer"),
			path: e.Syncer,
			icon: T(e.Syncer) ? S : d,
			advanced: !0
		},
		{
			title: w("configEditor.pages.analytics", "Analytics"),
			path: e.Analytics,
			icon: T(e.Analytics) ? h : i,
			advanced: !1
		},
		{
			title: w("configEditor.pages.cloudManager", "Cloud manager"),
			path: e.CloudManager,
			icon: T(e.CloudManager) ? _ : o,
			advanced: !0
		},
		{
			title: w("configEditor.pages.edgeBus", "Edge bus"),
			path: e.EdgeBus,
			icon: T(e.EdgeBus) ? y : c,
			advanced: !0
		},
		{
			title: w("configEditor.pages.variables", "Variables"),
			path: e.Variables,
			icon: T(e.Variables) ? m : r,
			advanced: !0
		},
		{
			title: w("configEditor.pages.triggers", "Triggers"),
			path: e.Triggers,
			icon: T(e.Triggers) ? x : u,
			advanced: !0
		}
	];
};
//#endregion
export { C as t };

//# sourceMappingURL=constants-DosvsSYo.js.map